import { colorPalette } from '../../colorPalette';
export const commonTransferStyles = () => ({
    commonText: {
        fontStyle: 'normal',
        textAlign: 'center',
        color: colorPalette.gray900,
    },
    commonTextNormal: {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '18px',
        padding: '0 0 8px',
    },
    commonTextBold: {
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
    },
    commonContentContainer: {
        paddingTop: '10px !important',
        overflow: 'inherit',
        maxHeight: '100%'
    },
});
